import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {showExactDate} from "../../../../config/values";
import {ChevronRight} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";

function ChangeOrderStatusFromMakingButton({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [orderStatus,setOrderStatus] = useState("delivering");
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/orders/change-status-from-making`, data, config);
            await reload();
            setSubmitLoading(false);
            await setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <>
            <Button
                className={classes.buttonAlert}
                onClick={() => setOpen(true)}
                endIcon={<ChevronRight/>}
                color="primary"
                variant="contained"
            >
                {t('doYouReceived')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle className="dialog-title">
                    {t('doYouReceived')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <Typography className="text-center bg-gray-box">{t('deliveryTimeIs')} <strong>{showExactDate(order.delivered_at)}</strong></Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography color="text"  className="text-center">{t('startDeliveringDesc')}</Typography>
                        </Grid>

                        <Grid item size={12}>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                            >
                                {t("confirm")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ChangeOrderStatusFromMakingButton));
